













































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetGift extends Vue {
  @Prop({ default: '35' }) readonly width?: string;
  @Prop({ default: '36' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
